import {restApi} from '../../../../../services/rest'

export const projectsSidebarApi = restApi.injectEndpoints({
  endpoints: build => ({
    getBuildTypesCount: build.query<number, void>({
      query: () => ({
        url: '/app/rest/buildTypes',
        params: {fields: 'count'},
      }),
      transformResponse: (data: {count: number}) => data.count,
    }),
  }),
})
